<template>
  <v-row justify="center" align="center" v-if="onboarding">
    <v-col lg="9" cols="12" sm="12">
      <Steps />
    </v-col>
  </v-row>
</template>

<script>
import Steps from "./Steps.vue";
export default {
  name: "DADA_view_steps",
  components: {
    Steps,
  },
  data() {
    return {};
  },
  computed: {
    onboarding() {
      const data = this.$store.state.analytics.onboarding;
      return data;
    },
  },
};
</script>
